"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultConfigurationApplied = void 0;
/**
 * A builder for DefaultConfigurationApplied
 *
 * @param data - The event data
 * @return The formatted event data for DefaultConfigurationAppliedEvent
 */
function createDefaultConfigurationApplied(data) {
    return {
        name: 'DefaultConfigurationApplied',
        environments: ['device', 'browser'],
        data: data,
    };
}
exports.createDefaultConfigurationApplied = createDefaultConfigurationApplied;
//# sourceMappingURL=createDefaultConfigurationApplied.js.map